import { useRef, useState } from "react";
import { Paperclip, X } from "lucide-react";



export default function ComposePost({
  onClose,
  onSubmit,
  category,
}) {

  const [text, setText] = useState("");
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  // HANDLE IMAGE UPLOAD
  const handleFiles = (e) => {

    const files = [...e.target.files];

    const newMedia = files.map(file => ({

      file,

      preview: URL.createObjectURL(file),

      caption: ""

    }));

    setMedia(prev => [

      ...prev,

      ...newMedia

    ]);

  };

  // CREATE POST
  const handlePost = async () => {

    if (!text.trim() && media.length === 0) {

      return;

    }

    try {

      setLoading(true);

      const formData = new FormData();

      formData.append("content", text);

      formData.append("category", category);

      media.forEach(item => {

        formData.append(

          "files",

          item.file

        );

      });

      formData.append(

        "captions",

        JSON.stringify(

          media.map(

            item => item.caption

          )

        )

      );

      await onSubmit(formData);

      setText("");

      setMedia([]);

      onClose();

    }

    catch (err) {
      console.error(err);

    }

    finally {

      setLoading(false);

    }

  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">

      <div className="bg-white rounded-[32px] w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl">

        {/* HEADER */}
        <div className="sticky top-0 bg-white z-20 px-6 py-5 border-b border-gray-100 flex items-center justify-between">

          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              Create Post
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              Share something with the {category} community
            </p>
          </div>

          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition"
          >
            <X size={18} />
          </button>
        </div>

        {/* BODY */}
        <div className="p-6">

          {/* POST TEXT */}
          <textarea
            rows={4}
            placeholder="What's happening in your world?"
            value={text}
            onChange={(e) => setText(e.target.value)}
            className="
              w-full
              resize-none
              border-none
              outline-none
              text-lg
              placeholder:text-gray-400
            "
          />

          {/* HIDDEN FILE INPUT */}
          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept="image/*"
            className="hidden"
            onChange={handleFiles}
          />

          {/* ACTION BAR */}
          <div className="flex items-center justify-between mt-6">

            {/* ATTACH BUTTON */}
            <button
              type="button"
              onClick={() => fileInputRef.current.click()}
              className="
                w-12 h-12
                rounded-full
                bg-gray-100
                hover:bg-gray-200
                flex items-center justify-center
                transition
              "
            >
              <Paperclip size={18} />
            </button>

            <div className="text-sm text-gray-400">
              Add photos & creative moments
            </div>
          </div>

          {/* MEDIA PREVIEW */}
          {media.length > 0 && (

            <div className="space-y-6 mt-6">

              {media.map((m, index) => (

                <div
                  key={index}
                  className="
                    relative
                    border
                    border-gray-200
                    rounded-[28px]
                    overflow-hidden
                    bg-gray-50
                  "
                >

                  {/* REMOVE IMAGE */}
                  <button
                    onClick={() => {
                      setMedia(media.filter((_, i) => i !== index));
                    }}
                    className="
                      absolute
                      top-4
                      right-4
                      z-10
                      w-8
                      h-8
                      rounded-full
                      bg-black/70
                      text-white
                      flex
                      items-center
                      justify-center
                    "
                  >
                    <X size={14} />
                  </button>

                  {/* IMAGE */}
                  <img
                    src={m.preview}
                    alt=""
                    className="
                      w-full
                      max-h-[420px]
                      object-cover
                    "
                  />

                  {/* IMAGE CAPTION */}
                  <div className="bg-white p-4">

                    <textarea
                      placeholder="Add caption or summary..."
                      value={m.caption}
                      onChange={(e) => {

                        setMedia(prev =>

                          prev.map((item, i) =>

                            i === index

                              ? {

                                ...item,

                                caption: e.target.value

                              }

                              : item

                          )

                        );
                      }}
                      className="
                        w-full
                        resize-none
                        outline-none
                        text-sm
                        placeholder:text-gray-400
                      "
                      rows={2}
                    />

                  </div>

                </div>
              ))}
            </div>
          )}

        </div>

        {/* FOOTER */}
        <div className="sticky bottom-0 bg-white border-t border-gray-100 px-6 py-4 flex justify-between items-center">

          <button
            onClick={onClose}
            className="
              px-5 py-2
              rounded-full
              bg-gray-100
              hover:bg-gray-200
              text-sm
              font-medium
              transition
            "
          >
            Cancel
          </button>

          <button
            onClick={handlePost}
            disabled={loading}
            className="
              px-8 py-3
              rounded-full
              bg-black
              text-white
              font-semibold
              hover:scale-105
              transition
              disabled:opacity-50
            "
          >
            {loading ? "Posting..." : "Post"}
          </button>
        </div>
      </div>
    </div>
  );
}